<template>
  <modal ref="notificatorModal" height="auto" name="notificator-editor" @before-open="beforeOpen">
    <div class="modal-header">
      <h2><i class="far fa-bell"></i> Create a new notificator</h2>
    </div>

		<div v-if="type">
			<form class="form-horizontal">
				<div class="notificator-email-type" v-if="type === 'email'">
					<div class="form-group">
						<div class="col-3">
							<label class="form-label" for="input-example-4">Email address</label>
						</div>
						<div class="col-9">
							<input class="form-input" type="email" id="input-example-4" v-model="notificator.properties.EmailAddress" placeholder="Email">
              {{ notificator.properties.EmailAddress }}
						</div>
					</div>
				</div>

				<!-- SMS -->
				<div class="notificator-sms-type" v-else-if="type === 'sms'">
					<div class="form-group">
						<div class="col-3">
							<label class="form-label" for="input-example-4">Phone number</label>
						</div>
						<div class="col-9">
							<input class="form-input" type="text" id="input-example-4" v-model="notificator.properties.PhoneNumber" placeholder="+4012312312312">
						</div>
					</div>
				</div>


				<!-- telegram -->
				<div class="notificator-webhook-type" v-else-if="type === 'telegram'">
					<p>In order to proceed with telegram you need to give us permission to send you messages</p>
					<div id="telegram_container" ref="telegram_container"></div>
				</div>

				<!-- webhook -->
				<div class="notificator-webhook-type" v-else-if="type === 'webhook'">
					<div class="form-group">
						<div class="col-3">
							<label class="form-label" for="input-example-4">URL</label>
						</div>
						<div class="col-9">
							<input class="form-input" type="text" id="input-example-4" v-model="notificator.properties.URL" placeholder="http(s)://...">
						</div>
					</div>
				</div>

        <!-- slack -->
				<div class="notificator-webhook-type" v-else-if="type === 'slack'">
					<div class="form-group">
						<div class="col-3">
							<label class="form-label" for="input-example-4">URL</label>
						</div>
						<div class="col-9">
							<input class="form-input" type="text" id="input-example-4" v-model="notificator.properties.URL" placeholder="Slack room URL">
						</div>
					</div>
				</div>

        <!-- slack -->
				<div class="notificator-webhook-type" v-else-if="type === 'slack'">
					<div class="form-group">
						<div class="col-3">
							<label class="form-label" for="input-example-4">URL</label>
						</div>
						<div class="col-9">
							<input class="form-input" type="text" id="input-example-4" v-model="notificator.properties.URL" placeholder="Slack room URL">
						</div>
					</div>
				</div>

				<button class="btn btn-primary" v-on:click.prevent="saveNotificator()">Save</button>
			</form>
		</div>

    <!-- this is the notificator modal without any settings -->
    <div v-else>
      <p class="alert alert-info">Please select a notificator type.</p>
      <ul class="notificators-types">
        <li v-for="(item, index) in notificatorTypes" :key="index" v-on:click.prevent="setNotificatorType(index)">
          <span v-html="item"></span>
        </li>
      </ul>
    </div>

  </modal>
</template>
<script>
import API from "../api"

export default {
  name: 'notificator-modal',
  data() {
    return {
      type: false,
      notificator: {
        type: '',
        properties: {}
      },
      id: false,
      notificatorTypes: {
        "email" : '<i class="fal fa-envelope"></i> Email',
        "sms" : '<i class="fa fa-phone"></i> SMS',
        "telegram": '<i class="fab fa-telegram-plane"></i> Telegram',
        "webhook": '<i class="fas fa-link"></i> Webhook',
        "call": '<i class="fas fa-phone"></i> Phone Call',
        "twitter": '<i class="fab fa-twitter"></i> Twitter',
        "slack": '<i class="fab fa-slack"></i> Slack',
        "pushbullet": '<i class="fab fa-pushbullet"></i> Pushbullet',
        "trello": '<i class="fab fa-trello"></i> Trello',
      }
    }
  },
	watch: {
	},
  methods: {
		saveNotificator() {
      // if we've a notificator is already set
      if(_.isUndefined(this.notificator.id) == false) {
        API.notificators.Update(this.notificator).then(response => {
          this.$modal.hide('notificator-editor');
        });
      } else {
        // set the type here for gewd
        this.notificator.type = this.type;

        // create the new notificator
        API.notificators.Save(this.notificator).then(response => {
          if(response.id) {
            App.$toasted.success('A new notificator has been created succesfully!')
            // I'd like a way here to refresh the 
            this.$modal.hide('notificator-editor');
          }
        });
      }
		},
    beforeOpen(event) {
      var $that = this;
      if(_.isUndefined(event.params) == false && event.params.notificator_id) {
        this.$http.get(`notificators/${event.params.notificator_id}`).then(response => {
            $that.notificator = response.data
            $that.type = response.data.type


					if($that.type == 'telegram') {
						$that.showTelegram()
					}
        })
      } else {
				this.type = false;
			}
    },
    initTelegram() {
      let telegram = document.createElement('script')
      // telegram.setAttribute('async', '')
      telegram.setAttribute('src', 'https://telegram.org/js/telegram-widget.js?2')
      telegram.setAttribute('data-telegram-login', 'pagespybot')
      telegram.setAttribute('data-size', 'small')
      telegram.setAttribute('data-onauth', `onTelegramAuth(user)`)
      telegram.setAttribute('data-request-access', 'write')
      telegram.setAttribute('data-size', 'large')

			/*
			* A fun hack, givne that the telegram_container gets rendered only after the type
			* is set to telegram, this is the only way I could think at the moment on how to wait
			* for the element to appear, I assume that there're better vue ways to do this but
			* this should work for now.
			*/
			let telegramContainerInterval = setInterval(function() {
				let container = document.getElementById('telegram_container')

				if(container) {
					container.appendChild(telegram)
					clearInterval(telegramContainerInterval)
				}
			}, 300);

    },
    setNotificatorType(type) {
      this.type = type;

			if(this.type == 'telegram') {
				this.initTelegram()
			}
    }
  },
  created() {
  }
}
</script>

<style lang="scss">
.v--modal {
  .modal-header {
    background: linear-gradient(to bottom, #7abcff 0%,#60abf8 44%,#4096ee 100%);
    border-bottom: 1px solid #d7d7d7;
    box-shadow: 0px 1px 0px #b3dcff inset;
    border-radius: 3px 0px 3px 0px;

    h2 {
      margin: 0;
      font-size: 20px;
      padding: 6px;
      font-weight: bold;
      color: #fff;
      text-shadow: 0px 1px 0px #000;
    }
  }

  p.alert-info {
    background: #ffefbf;
    margin: 6px 6px;
    padding: 8px;
    border-radius: 2px;
  }

  .notificators-types {
    li {
      list-style: none;
      display: inline-block;
      border: 1px solid #d5d5d5;
      padding: 25px 13px;
      width: 48%;
      margin: 4px;
      border-radius: 2px;
      text-align: center;
      font-size: 20px;
      box-shadow: 2px 2px 2px #ededed;

      &:hover {
        cursor: pointer;
        box-shadow: 0px 0px 2px #ededed;
      }
    }
  }

	#telegram_container {
		width: 50%;
		margin: 0 auto;
		padding: 20px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/NotificatorModal.vue